export default "__VITE_ASSET__C83R4eQk__"